import { gql } from 'apollo-boost';

export const CREATE_REWARD_CARD = gql`
    mutation createRewardCard(
        $name: String!,
        $price: Int!,
        $power: Int!,
        $speed: Int!,
        $skill: Int!,
        $rewardCardPackId: ID!,
        $chapterWinnerOnly: Boolean!,
        $url: String!,
        $authorName: String
    ) {
        createRewardCard(
            name: $name,
            price: $price,
            power: $power,
            speed: $speed,
            skill: $skill,
            rewardCardPackId: $rewardCardPackId,
            chapterWinnerOnly: $chapterWinnerOnly,
            url: $url,
            authorName: $authorName
            ) {
            errors
            rewardCard {
                id
                name
            }
        }
    }
`;

export const EDIT_REWARD_CARD = gql`
    mutation editRewardCard(
        $rewardCardId: ID!
        $name: String!
        $price: Int!
        $power: Int!
        $speed: Int!
        $skill: Int!
        $chapterWinnerOnly: Boolean!
        $url: String!
        $authorName: String    
    ) {
        editRewardCard(
            rewardCardId: $rewardCardId
            name: $name
            price: $price
            power: $power
            speed: $speed
            skill: $skill
            chapterWinnerOnly: $chapterWinnerOnly
            url: $url
            authorName: $authorName
        ) {
            errors
            rewardCard {
                id
            }
        }
    }
`;

export const DELETE_REWARD_CARD = gql`
    mutation deleteRewardCard($rewardCardId: ID!) {
        deleteRewardCard(rewardCardId: $rewardCardId) {
            deleted
            errors
        }
    }
`

export const REWARD_CARDS = gql`
    query rewardCards($pack: String) {
        rewardCards(pack: $pack) {
                id
                name
                pack
                power
                price
                skill
                speed
                url
        }
    }
`;

export const REWARD_CARDS_BY_ID = gql`
    query rewardCardsById($rewardCardPackId: ID) {
        rewardCardsById(rewardCardPackId: $rewardCardPackId) {
                id
                name
                pack
                power
                price
                skill
                speed
                url
        }
    }
`;